module.exports = __webpack_public_path__ + "fab03d216628cbbfda68469e31af1d20.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/ss-junior/webfonts/ss-junior.svg
// module id = 42
// module chunks = 0 1 2 3 4 5 6 7 8 9